import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import ThemeToggle from "./ThemeToggle";
import logo from "../assets/norwoodlogo.png";

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showShareToast, setShowShareToast] = useState(false);

  const toggleMenu = () => setIsMenuOpen((open) => !open);

  return (
    <nav className="bg-white dark:bg-dark-surface shadow-sm relative font-sans transition-colors">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
         {/*  Logo */}
          <Link to="/" className="flex items-center space-x-0.5">
            {/* <img src={"https://hyogiqxohlfioprwfbdy.supabase.co/storage/v1/object/public/images/minimalistic_logo.png"} alt="WhenBald" className="h-12 w-auto" />*/}
            <span
              className="font-bold text-2xl tracking-tight text-gray-900 dark:text-dark-text"
              style={{
                fontFamily:
                  "'Inter', ui-sans-serif, system-ui, sans-serif",
              }}
            >
              <span>WhenBald</span>
              <span className="text-primary-700 dark:text-dark-text-secondary">
                .com
              </span>
            </span>
          </Link>

          {/* Right-side controls */}
          <div className="flex items-center gap-3">

            <button
              onClick={toggleMenu}
              className="text-gray-600 dark:text-dark-text-secondary hover:text-primary-700 dark:hover:text-primary-400 transition-colors"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="absolute top-16 left-0 right-0 bg-white dark:bg-dark-surface shadow-lg z-50 transition-colors">
          <div className="flex flex-col space-y-4 p-4">
            <Link
              to="/faq"
              className="text-gray-600 dark:text-dark-text-secondary hover:text-primary-700 dark:hover:text-primary-400 py-2 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              FAQ
            </Link>

            <Link
              to="/privacy"
              className="text-gray-600 dark:text-dark-text-secondary hover:text-primary-700 dark:hover:text-primary-400 py-2 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Privacy
            </Link>

            <Link
              to="/terms"
              className="text-gray-600 dark:text-dark-text-secondary hover:text-primary-700 dark:hover:text-primary-400 py-2 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Terms
            </Link>

            <Link
              to="/contact"
              className="text-gray-600 dark:text-dark-text-secondary hover:text-primary-700 dark:hover:text-primary-400 py-2 transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>


          </div>
        </div>
      )}

      {/* Share Toast */}
      {showShareToast && (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-4 py-2 rounded-lg shadow-lg text-sm">
          Link copied to clipboard!
        </div>
      )}
    </nav>
  );
};

export default Navbar;
